import { isMatch, isAfter, isBefore, isValid, parse } from 'date-fns'

export const alpha_extended = {
  messages:{
    en:(_field, _args) =>"Entry is not allowed",
    de:(_field, _args) =>"Eingabe ist nicht erlaubt"
  },
  getMessage:"",
  validate: (value,args) => {
    return  new Promise(resolve => {
      resolve({
        valid: resolve => !Array.isArray(value) && /^[a-zA-ZàâçéèêëîïôûùüÿñæœÀÂÇÉÈÊËÎÏÔÛÙÜŸÑÆŒäöüÄÖÜß\.\s]+$/.test(value)
      });
    });
  }
};


export const hslu_email = {
  messages:{
    en:(_field, _args) =>"Email is not an HSLU-Email",
    de:(_field, _args) =>"E-Mail ist keine HSLU E-Mail"
  },
    getMessage:"",
  validate: (value,args) => {
    return new Promise(resolve => {
      resolve({
        valid: resolve =>!Array.isArray(value) && /@hslu\.ch$/ig.test(value)
      });
    });
  }
};

export const no_hslu_email = {
  messages:{
    en:(_field, _args) =>"No HSLU-Email allowed",
    de:(_field, _args) =>"Es darf keine HSLU E-Mail angegeben werden"
  },
  getMessage:"",
  validate: (value,args) => {
    return new  Promise((resolve) => 
      resolve({
        valid:  !Array.isArray(value) && !/@hslu\.ch$/ig.test(value) && !/@stud.hslu\.ch$/ig.test(value)
      })
    );
  }
};

export const dateFormat = {
  messages: {
    en: (_field, _args) => 'Date format not allowed',
    de: (_field, _args) => 'Datum format nicht erlaubt'
  },
  getMessage: '',
  validate: (value, args) => {
    return new Promise((resolve) => {
      resolve({
        valid: !Array.isArray(value) && isMatch(value, args[0]) && isValid(parse(value, args[0], new Date()))
      })
    })
  }
}
export const dateBetween = {
  messages: {
    en: (_field, _args) => 'Date format not allowed',
    de: (_field, _args) => 'Datum format nicht erlaubt'
  },
  getMessage: '',
  validate: (value, args) => {
    console.log(value)
    console.log(args)
    
    return new Promise((resolve) => {
      resolve({
        valid: !Array.isArray(value) && isAfter(parse(value, args[2], new Date()),parse(args[0], args[2], new Date()))  && isBefore(parse(value, args[2], new Date()),parse(args[1], args[2], new Date()))
      })
    })
  }
}
export const telFormat = {
  messages: {
    en: (_field, _args) => 'Phone format not allowed',
    de: (_field, _args) => 'Phone format nicht erlaubt'
  },
  getMessage: '',
  validate: (value, _args) => {
    return new Promise((resolve) => {
      resolve({
        valid: value && /^\+[0-9]{2}(\s?[0-9]){9,10}$/.test(value)
      })
    })
  }
}
export const isInteger = {
  messages: {
    en: (_field, _args) => 'Entry is not allowed',
    de: (_field, _args) => 'Eingabe ist nicht erlaubt'
  },
  getMessage: '',
  validate: (value, _args) => {
   return new Promise((resolve) => {
      resolve({
        valid: !Array.isArray(value) && /^([0-9]+)$/.test(value)
      })
    })
  }
}
export const isDecimal = {
  messages: {
    en: (_field, _args) => 'Entry is not allowed',
    de: (_field, _args) => 'Eingabe ist nicht erlaubt'
  },
  getMessage: '',
  validate: (value, _args) => {
    return new Promise((resolve) => {
      resolve({
        valid: !Array.isArray(value) && /^\d+(\.\d{1,2})?$/.test(value)
      })
    })
  }
}
